
import store from '../../store';
import Vue from 'vue';

const success = (data, resolve) => {
  const avialableWidgetsData = data;
  store.dispatch('fetchAvailableWidgets', { avialableWidgetsData });
  resolve();
};

const failed = (error, reject) => reject(error);

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('user-widgets/available')
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/widgets/fetchAvailableWidgets.js